import { StatusModel } from '../general';
import { GraphMetrics, GraphMetricsId } from '../shared/components/graph';

export interface DeviceHostMetadataModel {
  hostName: string;
  containerized: boolean;
  os: {
    name: string;
    kernel: string;
  },
  cloud: {
    provider: string;
    availabilityZone: string;
    machineType: string;
    projectId: string;
  },
  instance: {
    id: string;
    name: string;
  },
  lastActiveTime: string;
  restartsCount: string;
  uptimeDuration: string;
}

export interface DeviceHostMetadataModelV1 {
  Architecture: string;
  KernelVersion: string;
  NumCpus: number;
  OperatingSystem: string;
  OperatingSystemType: string;
  Provisioning: {
    AlwaysReprovisionOnStartup: boolean;
    DynamicReprovisioning: boolean;
    Type: string
  },
  ServerVersion: string;
  TotalMemory: number;
  Version: string;
  Virtualized: boolean;
}

export interface DeviceHostMetricsModel {
  graphIndices: GraphMetrics[];
  overview: DeviceHostMetricsOverview;
}

export interface DeviceHostMetricsOverview {
  id: GraphMetricsId;
  label: string;
  utilisation: StatusModel;
  series: DeviceHostMetricsOverviewSeries[];
}

export interface DeviceHostMetricsOverviewSeries {
  id: string;
  label: string;
  unit: string;
  value: number;
  valueInPercent: number;
  utilisation: StatusModel;
  calculationMethod: string;
}

export interface DeviceHostSidePanel{
hoverText: string;
id: string;
isActive: string;
name: string;
}

export interface HostOverViewModel{
  id:string;
  status:
  {
    status:StatusModel;
    unit:string;
    value:number;
    valueInPercent?:number;
  };
  name:string;
  hoverText:string;
  isActive:string;
  isSelected:boolean;        
}